import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const fileReadNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('fileRead'),
    controlValues: z.object({
        encoding: z.enum([ 'utf-8', 'ascii', 'latin1', 'utf16le', 'base64', 'hex' ]).default('utf-8'),
    }),
});

export interface FileReadNodeCfgSchema extends z.infer<typeof fileReadNodeCfgSchema> {}

export const fileReadNodeCfg = {
    controlSockets: {
        inputs: () => ({ trigger: 'event' }),
        outputs: () => ({ next: 'event' }),
    },
    dataSockets: {
        inputs: () => ({
            filePath: 'string',
        }),
        outputs: () => ({
            fileContents: 'string',
        }),
    },
} satisfies NodeSocketCfg<FileReadNodeCfgSchema>;
